<template>
  <div class="white-bg">
    <div class="card-top flex flex-wrap relative">
      <div class="col-2 sm-hide xs-hide">
        <img
          :src="commonAttributes.product_image"
          :alt="commonAttributes.product_name"
          :title="commonAttributes.product_name"
          width="64"
        >
      </div>
      <div class="sm-col-12 col-10 md-col-8">
        <div class="col-12">
          <h3 class="my0">{{ commonAttributes.product_name }}</h3>
        </div>
        <span class="h3">{{ commonAttributes.product_type }} </span>
        <span class="h3"><span>(x{{ totalQuantity }})</span><span v-if="hasSession">- {{ commonAttributes.session.name }}</span></span>
        <div class="flex col-12 sm-hide md-hide lg-hide">
          <span class="h3 right bold">
            <span v-if="!isGymlibSale && parseFloat(value) < parseFloat(totalPrice)" class="crossed">{{ totalPrice }} €</span>
            <div v-if="!isGymlibSale">{{ value > 0 ? `${value} €` : 'Offert' }}</div>
          </span>
        </div>
        <div v-if="hasSession && commonAttributes.offer_type !== 'STAGE'" class="flex h7n mt1">
          <!-- <div v-if="hasSession" class="flex h7n mt1"> -->
          <i class="icon icon-date-check-icon mr1"></i> {{ formatSession(commonAttributes.session.start_time, 'dd/MM/yyyy') }}
          <i class="icon icon-clock mx1"></i> {{ formatSession(commonAttributes.session.start_time, "HH'h'mm") }} - {{ formatSession(commonAttributes.session.end_time, "HH'h'mm") }}
        </div>
        <div v-if="hasSession && commonAttributes.offer_type === 'STAGE'" class="flex h7n mt1">
          <i class="icon icon-date-check-icon mr1"></i>Du {{ formatSession(commonAttributes.session.start_time, 'dd/MM/yyyy') }} au {{ format(commonAttributes.session.last_time, 'dd/MM/yyyy') }}
          <i class="icon icon-clock mx1"></i>À partir de {{ formatSession(commonAttributes.session.start_time, "HH'h'") }}
        </div>
        <div>
          <span v-if="commonAttributes.reservation" class="h6">
            Information, l'annulation sera impossible pour ces séances
          </span>
        </div>
      </div>
      <div class="col-2 xs-hide">
        <span class="h3 right bold col-12">
          <span v-if="!isGymlibSale && parseFloat(value) < parseFloat(totalPrice)" class="crossed">{{ totalPrice }} €</span>
          <div v-if="!isGymlibSale">{{ value > 0 ? `${value} €` : 'Offert' }}</div>
        </span>
        <!-- <span v-if="isProrataPrix" class="col-12">Pro rata prix</span> -->
      </div>
      <div v-if="isCartRecap" class="absolute remove-item">
        <i :class="['icon pointer', { 'icon icon-loader flex': removeLoading, 'icon-trash': !removeLoading }]" @click="removeClick"></i>
      </div>
    </div>
    <div v-if="item.details && item.details[0] && item.details[0].tda_info" class="px4 pb2 justify tda-info" v-html="item.details[0].tda_info"></div>
    <div :id="`details-${componentUid}`" :class="['pointer h4n border-top border-bottom col-12 flex flex-wrap items-center details', { 'open': isDetailsOpen }]" @click="toggleDetails">
      <div class="col-12 flex flex-wrap">
        <div class="col-11">
          <span>Plus de détails</span>
        </div>
        <div class="col-1 right-align">
          <i style="top: 4px" :class="['icon', { 'icon-chevron-down': !isDetailsOpen, 'icon-chevron-up': isDetailsOpen }]"></i>
        </div>
      </div>

      <div :id="`details-content-${componentUid}`" class="col-12 pt2">
        <div v-for="(detail, index) in item.details" :key="index">
          <span class="bold h5">{{ detail.categoryLabel || detail.price_category }}</span>
          <div class="pl3 flex flex-wrap items-center">
            <div class="col-12 relative">
              <i style="top: 2px; left: -25px" class="icon-buddy absolute"></i>
              <span class="h6n">Participants:</span>
            </div>
            <div class="flex col-12 flex-wrap">
              <span class="flex col-12 lg-col-6 items-center">{{ detail.participant.firstname }} {{ detail.participant.lastname }} (x{{ detail.quantity }})</span>
              <div v-if="!detail.gymlibCode" class="flex flex-wrap col-12 lg-col-6 justify-end">
                <div v-if="parseFloat(detail.price/100) < computeOriginalPrice(detail)" class="flex justify-end col-12 crossed">{{ computeOriginalPrice(detail).toFixed(2) }} €</div>
                <div v-if="priceWithDecimals(detail.price) > 0" class="flex flex-wrap justify-end col-12 right">
                  <div class="flex justify-end">
                    {{ priceWithDecimals((proRata ? detail.proRataPrice / 100 : detail.price / 100)) }} €
                  </div>
                  <div v-if="commonAttributes.recurring" class="flex ml1 h5 justify-end ">
                    / mois
                  </div>
                </div>
                <div v-else class="flex col-12 right">Offert</div>
              </div>
              <div v-else class="flex col-12 h5">Code EGYM Wellpass: {{ detail.gymlibCode }}</div>
            </div>
            <div v-for="(option, i) in detail.options" :key="i" class="col-12">
              <div class="h6 col-12 flex no-box">
                <div class="ml2 flex col-6 flex-auto items-center">
                  <i class="icon icon-add-more-icon pr1"></i>
                  <span>{{ option.name }} (x{{ option.quantity }})</span>
                </div>
                <div class="flex col-6 justify-end">
                  <span v-if="parseFloat(option.price/100) < computeOriginalPrice(option)" class="crossed mr1">{{ computeOriginalPrice(option).toFixed(2) }} €</span>
                  <span v-if="option.price > 0" class="bold">{{ priceWithDecimals(option.price / 100) }}€ <span v-if="commonAttributes.recurring && !option.registrationFees"> / mois</span></span>
                  <span v-else class="bold">Offert</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useId } from 'vue';
import { format } from 'date-fns';

import { removeShoppingCart } from '@/utils/requests';
import { priceWithDecimals, computeTotalPrice } from '@/utils/labels';
import { frenchTime } from '@/utils/utils';
import { computeCommonAttributes } from '@/utils/logics';

export default {
  props: {
    item: Object,
    value: [Number, String],
    isCartRecap: Boolean,
    proRata: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    return { componentUid: useId() };
  },
  data () {
    return {
      isDetailsOpen: false,
      removeLoading: false
    };
  },
  computed: {
    isProrataPrix () {
      return this.item.details.some(detail => detail.proRataPrice);
    },
    detail () { return this.item.details[0]; },
    isGymlibSale () { return !!this.item.details.some(d => d.gymlibCode); },
    participant () { return this.detail.participant; },
    cartParticipant () { return this.$store.state.cartItem.participants.find(p => p.uuid === this.participant.uuid); },
    options () {
      return this.cartParticipant.options?.reduce((acc, prev) => acc.concat([{ ...prev.price, quantity: prev.quantity }]), []);
    },
    tariff () {
      return this.cartParticipant.tariff;
    },
    totalPrice () {
      return this.groupedTariffs.reduce((acc, tariff) => acc + tariff.participants.reduce((a, participant) => a + participant.price, 0), 0).toFixed(2);
    },
    siteInfo () {
      return this.$store.state.siteInfo;
    },
    hasSession () {
      return !!this.commonAttributes.session;
    },
    commonAttributes () {
      return {
        ...computeCommonAttributes(this.detail),
        price: this.detail.price.toFixed(2),
        options: this.detail.options
      };
    },
    groupedTariffs () {
      const tariffs = [];
      this.item.details.map(detail => {
        let tariffIndex = tariffs.findIndex(tariff => tariff.code === detail.tariffCode);
        if (tariffIndex === -1) {
          tariffs.push({ code: detail.tariffCategoryCode, label: detail.categoryLabel, participants: [] });
          tariffIndex = tariffs.length - 1;
        }

        tariffs[tariffIndex].participants.push({
          firstname: detail.participant.firstname,
          lastname: detail.participant.lastname,
          quantity: detail.quantity,
          price: this.computeTotalPrice([{ details: [detail] }])
        });

        return detail;
      });
      return tariffs;
    },
    totalQuantity () {
      return this.item.details.reduce((acc, detail) => acc + detail.quantity, 0.0);
    }
  },
  methods: {
    format,
    priceWithDecimals,
    computeTotalPrice,
    frenchTime,
    toggleDetails () {
      this.isDetailsOpen = !this.isDetailsOpen;
      this.growCollapsible();
    },
    growCollapsible () {
      const element = document.querySelector(`#details-${this.componentUid}`);
      if (this.isDetailsOpen) {
        const content = document.querySelector(`#details-content-${this.componentUid}`);
        element.style.height = `${element.offsetHeight + content.offsetHeight}px`;
      } else {
        element.style.height = '63px';
      }
    },
    async removeClick () {
      this.removeLoading = true;

      await removeShoppingCart()
        .then(resp => {
          this.$store.commit('addCartItemToCart', resp);
          this.removeLoading = false;
        });
    },
    formatSession (time, dateFormat) {
      return this.frenchTime(parseInt(time), dateFormat, this.siteInfo.timezone);
    },
    computeOriginalPrice (detail) {
      let price = null;
      if (detail.hasOwnProperty('options')) {
        price = (this.tariff.isGymlibTariff ? this.tariff.negotiatedPrice : this.tariff.price) * this.cartParticipant.quantity;
      } else {
        const option = (this.cartParticipant.options || []).find(o => {
          if (o.hasOwnProperty('tariffCode')) {
            return o.tariffCode === detail.tariffCode;
          }
          return o.price.tariffCode === detail.tariffCode;
        });

        if (option) {
          const quantity = option.quantity || 1;
          price = option.price * quantity;
        }
      }
      return parseFloat(parseInt(price) / 100);
    }
  }
};
</script>

<style lang="scss" scoped>
  .details {
    padding: 1rem 4rem;
    user-select: none;
    height: 63px;
    overflow: hidden;
    transition: height 0.2s linear;
  }

  @media (max-width: 40em) {
    .details {
      padding: 1rem 2rem;
    }
  }

  .remove-item {
    top: 10px;
    right: 10px;
  }
</style>
